import { LogoutOptions, useAuth0 } from "@auth0/auth0-react";
import { Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import { IoLogOutOutline } from "react-icons/io5";
import Logo from "../Logo/Logo";

interface NavbarHeaderProps {
  onToggleSidebar?: () => void;
}

const NavbarHeader = ({ onToggleSidebar }: NavbarHeaderProps) => {
  const { isAuthenticated, logout } = useAuth0();

  const handleLogout = () => {
    const auth0LogoutOptions: LogoutOptions = {
      returnTo: window.location.origin,
      federated: false,
      localOnly: false,
    };
    logout(auth0LogoutOptions);
  };

  return (
    <Navbar expand="lg" data-testid="header" className="bg-black h-[73px]">
      <button
        onClick={onToggleSidebar}
        className="md:hidden text-white p-2 ml-2 focus:outline-none"
        aria-label="Toggle sidebar"
      >
        <FiMenu size={24} />
      </button>

      {/* Logo - show only on mobile */}
      <div className="md:hidden flex-grow flex justify-center">
        <Logo showOnlyOnMobile />
      </div>

      {/* Mobile Logout Button */}
      {isAuthenticated && (
        <div className="md:hidden flex items-center mx-2">
          <Link
            to="/"
            onClick={handleLogout}
            className="text-white flex items-center p-2"
            aria-label="Logout"
          >
            <IoLogOutOutline size={24} />
          </Link>
        </div>
      )}

      {/* Desktop Menu */}
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="me-auto"></Nav>
        <Nav className="p-12">
          {isAuthenticated && (
            <Nav.Link
              as={Link}
              to="/"
              onClick={handleLogout}
              className="flex items-center"
            >
              <IoLogOutOutline size={20} className="mr-1" /> Logout
            </Nav.Link>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarHeader;
